import * as React from "react";
import {Row, Col, InputNumber} from "rsuite";
import Pagination  from "../../components/common/pagination";
import { headCells } from "./constant";
import Sorting from "../../components/common/sorting";
import { rootShouldForwardProp } from "@mui/material/styles/styled";
import { getCrossSellCustomerList } from "../../queries/apiQueries";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export class Table extends React.Component<any, any> {
    headerStyle = { backgroundColor: "black", color: "white", borderRight: "0.1px solid #333231", borderBottom: "0.2px solid rgb(117, 189, 8)" };
    fontSize = "0.85vw";
    fieldMatchColumns: any = { "Product Type": "productType", "Item Type": "itemId", "Cases/year (prior 52 weeks)": "vol", "Revenue/year (prior 52 weeks)": "rev", "Loaded Opportunity($)": "opport" };
    columnStyle = {
        backgroundColor: "#1a1916", color: "white",
        borderRight: "0.1px solid #333231", borderBottom: "0.1px solid #333231", innerHeight: "36px",
    };
    isFirstTime: boolean = true;
    defaultPageSize: number = 10;
    debounceTimeOutId: any = null;
    debounceTimeOutId1: any = null;

    constructor(props: any) {
        super(props);
        this.state = {
            tableHeight: 250,
            checked: false,
            checked2: false,
            rowHighlightIndex: null,
            pageSize: 10,
            PageNumber: 1,
            orderBy: "marginOpportunity",
            order: "desc",
            setOrderForSorting: null,
            pageSizeValue: 10,
            FilteredCustomers : []
        };
    }


    thousands = (value: any) => {
        if (value < 1000) {
            return value;
        } else {
            return `${Math.round(value / 1000)}`.replace(/(?=(?!(\b))(\d{3})+$)/g, "$1,") + 'K';
        }
    }

    setOrderForSorting = (order: any, orderBy: any) => {
        this.setState({
            order,
            orderBy
        });

        this.props.setPayloadVariables([] , order, orderBy, this.state.pageSize, this.state.PageNumber, this.props.isUpSell);
    }

    handleChangePage = (event: any, newPage: any) => {
        this.setState({
            PageNumber: newPage
        });

        this.props.handlePaginationAPI(this.state.pageSize, newPage, this.props.isUpSell);
    }

    handleExpansion = (itemId: string) => {
        const arr = this.props.expandedRows;
        if (arr.includes(itemId)) {
            arr.splice(arr.indexOf(itemId), 1);
            this.fontSize = "0.75vw";
        } else {
            arr.push(itemId);
            this.fontSize = "0.63vw";
        }
        this.props.setExpendedRowArray(arr);
    }

    handleRowClickLocal = (event: any, index: any) => {
        console.log(this.state.rowHighlightIndex , event.name)
        console.log (this.state.rowHighlightIndex === event.name)
        let i=index
        if (this.state.rowHighlightIndex === event.name) {
            index = null;
        }
        console.log(this.state.rowHighlightIndex&&!this.props?.isRowHighlighted)
        if(this.state.rowHighlightIndex&&!this.props?.isRowHighlighted){
            index = i;
        }
        console.log(index)
        this.setState({
            rowHighlightIndex: index === null ? null : event.name,
        });
        this.props.handleRowClick(event, index);
        this.props.isRowHighlightedRequired(true);
    }

    calcLength(arr: any) {
        let res = arr.filter((d1: any) => d1.marginOpportunity > 0);
        return res.length;
    }

    AsyncToggle = () => this.setState({ checked: !this.state.checked });

    AsyncToggleForExecution = () => {
        this.setState({ checked2: !this.state.checked2 });
    }

    handleChangeInputValue = (value: any, event: any) => {
        if (/^0/.test(value)) {
            value = value.replace(/^0/, "");
        }

        this.setState({
            pageSizeValue: value,
        })

        if (this.debounceTimeOutId) {
            clearTimeout(this.debounceTimeOutId);
        }
        this.debounceTimeOutId = setTimeout(() => {
            this.setState({
                pageSize: value
            });
            this.props.handlePaginationAPI(value === "" ? this.defaultPageSize : value, this.state.pageNumber, this.props.isUpSell);
        }, 1000);
    }

    UpdateTableDataBasedOnFilter = () => {
        getCrossSellCustomerList({
            data : this.state.FilteredCustomers
        })
        return null
    }

    handleRecAcceptDecline=(data:any,type:boolean=false)=>{
        if(type){
            this.props.handleRecReject([{customer:data?.customer[0],location:data?.location_v1[0],l3:data?.l4[0]}])
        }else{
            this.props.handleRecAccept(data)
        }
    }

    rejectAllhandler=(data:any)=>{
        console.log(data,'reject')
        let finalData:any=[],obj={}

        data?.forEach((value:any)=>{
            obj={
                customer:value?.customer,
                location:value?.location,
                l3:value?.l4
            }
            finalData.push(obj)
        })

        this.props.handleRecReject(finalData)
    }

    render(): React.ReactNode {
        const { data, sortFn, sortObj, handleRecAccept, isUpSell, powerBiSelectedCustomer, isRowHighlighted, expandedRows,
            totalPages } = this.props;
        if (powerBiSelectedCustomer) {
            if (data && data.list && this.isFirstTime) {
                data.list.forEach((d: any, index: number) => {
                    if (d.id === powerBiSelectedCustomer) {
                        this.handleExpansion(d.id);
                        this.handleRowClickLocal(d, index);
                    }
                });
                this.isFirstTime = false;
            }
        }
        const { rowHighlightIndex } = this.state;
        let hCol = Object.assign({}, this.columnStyle);

        hCol.backgroundColor = "#383838";
        return <>
            <Row style={{ height: "87%" }} className="show-grid">
                <Col className="leftTable" style={{ height: "100%" }} xs={24} sm={24} md={24}>
                    <table className="fixed_header crossSell">
                        <tbody className="tbodyClass tbodyClassScroll" style={{ fontSize: this.fontSize }}>
                           <tr style={{ cursor: "pointer" }}>
                                <Sorting orderBy ={this.state.orderBy} order={this.state.order} headCell={headCells[0]} setOrderForSorting={this.setOrderForSorting} rowSpan = {2}/>
                                <th className="alginCenter itemTableHeader" style={this.headerStyle} colSpan={isUpSell ? 5 : 4}>Recommendation</th>
                                <th className="alginCenter itemTableHeader" style={this.headerStyle} rowSpan={2}>Action</th>
                            </tr>
                            <tr style={{ cursor: "pointer" }}>
                                {headCells.map((headCell: any) => 
                                    (headCell.id === "l4" || headCell.id === "quantity" || headCell.id === "currentPortfolio" ||
                                    (!this.props.isUpSell && headCell.id === "marginOpportunity")
                                    || (this.props.isUpSell && (headCell.id === "currentRevenue" || headCell.id === "aditionalMarginOpportunity"))) ?
                                        <Sorting orderBy ={this.state.orderBy} order={this.state.order} headCell={headCell} setOrderForSorting={this.setOrderForSorting} 
                                        rowSpan = {1}/> : <></>
                                )}
                            </tr>
                            
                            {data && data.list && data.list.sort((a: any, b: any) => b.marginOpp - a.marginOpp).map((d: any, pIndex: number) => {
                                
                                return <>
                                    <tr className={(isRowHighlighted === true && rowHighlightIndex !== null && rowHighlightIndex !== d.name) ? "dim cursorPointer" : "cursorPointer"}>
                                        <td style={this.columnStyle}>
                                            <label className="rowClickIcon cursorPointer" onClick={() => this.handleExpansion(d.name)}>
                                                {expandedRows && expandedRows.includes(d.name) ? 
                                                // <i className="fa">&#xf056;</i> 
                                                <MinusRoundIcon/>
                                                :
                                                // <i className="fa">&#xf055;</i>
                                                <PlusRoundIcon/>
                                                }</label>
                                            <label className="cursorPointer" onClick={() => this.handleRowClickLocal(d, pIndex)}>{d.name}</label></td>
                                        <td onClick={() => this.handleRowClickLocal(d, pIndex)} style={this.columnStyle}>Total:{this.calcLength(d.list)}
                                        </td>
                                        <td onClick={() => this.handleRowClickLocal(d, pIndex)} className="alignRight" style={this.columnStyle}>{numberFormatter(d.total.quantity)}</td>
                                        <td onClick={() => this.handleRowClickLocal(d, pIndex)} className="alignRight" style={this.columnStyle}>${numberFormatter(d.total.revenue)}</td>
                                        <td onClick={() => this.handleRowClickLocal(d, pIndex)} className="alignRight" style={this.columnStyle}>${numberFormatter(d.total.marginOpp)}</td>
                                        {isUpSell ? <td className="alignRight" style={this.columnStyle}>${this.thousands(Math.round(d.total.additionalMarginOpp))}</td> : ""}
                                        <td className="alignCenter cursorPointer" style={this.columnStyle}>
                                            <button  style={{ width: "3.2vw", fontSize: "0.55vw", marginRight: "1px" }}
                                                onClick={() =>d.isAgreed==0? handleRecAccept({customer:[d?.id],location_v1:[],l4:[]}):this.rejectAllhandler(d.list)} className={d.isAgreed==0 ? "buttonMargin acceptAll" : "greyNackground"}>Accept All</button>
                                        </td>
                                    </tr>
                                    {expandedRows && expandedRows.includes(d.name) ? d.list.sort((a: any, b: any) => b.marginOpportunity - a.marginOpportunity).map((d1: any, index: number) => {
                                        let hCol = Object.assign({}, this.columnStyle);
                                        hCol.backgroundColor = "#383838";
                                        return <>
                                            <tr hidden={d1.marginOpportunity == 0} style={{ backgroundColor: "#383838" }} className={(rowHighlightIndex !== null && rowHighlightIndex !== d.name) ? "dim" : ""}>
                                                <td style={hCol}></td>
                                                <td className="alignRight cursorPointer" style={hCol}>{d1.l4}</td>
                                                <td className="alignRight cursorPointer" style={hCol}>{numberFormatter(d1.quantity)}</td>
                                                <td className="alignRight cursorPointer" style={hCol}>${numberFormatter(d1.currentPortfolio)}</td>
                                                <td className="cursorPointer alignRight" style={hCol}>${numberFormatter(d1.marginOpportunity)}</td>
                                                {isUpSell ? <td className="cursorPointer alignCenter" style={hCol}>${numberFormatter(d1.aditionalMarginOpportunity)}</td> : ""}
                                                <td className="alignCenter cursorPointer" style={hCol}>
                                                    {/* <i style={(d1.isAgreed==0) ?
                                                        {background: "green"} : { background: "grey" }}
                                                        className={"fa fa-check acceptIcon"} onClick={() => this.handleRecAcceptDecline({customer:[d?.id],location_v1:[d1?.location],l4:[d1?.l4]},d1.isAgreed==0?false:true)} aria-hidden="true">
                                                    </i> */}
                                                    <CheckBoxIcon sx={{ color: `${(d1.isAgreed==0)?'green':'gray'}` }} 
                                                    onClick={() => this.handleRecAcceptDecline({customer:[d?.id],location_v1:[d1?.location],l4:[d1?.l4]},d1.isAgreed==0?false:true)}
                                                    />
                                                </td>
                                            </tr>
                                        </>
                                    }) : ""}
                                </>
                            })}
                        </tbody>
                    </table>
                </Col>
            </Row>
            <Row className="footerRow">
            <Row style={{ height: "8%", position: 'relative', top:'2vh', right:'1vw'}} className="show-grid">
                <Col xs={24} sm={24} md={4} />
                <Col xs={24} sm={24} md={14}>
                    <Pagination totalPages={totalPages} handleChangePage={this.handleChangePage} pageSize={this.state.pageSize === "" ? this.defaultPageSize : this.state.pageSize} pageNumber={this.state.PageNumber} />
                </Col>
                <Col xs={24} sm={24} md={6}>
                    <label style={{color: 'white', fontSize: '1.7vh'}}>
                        Rows per page:
                    </label>
                    <InputNumber value={this.state.pageSizeValue} onChange= {this.handleChangeInputValue} style={{width: '3.5vw', padding: '1%', float: 'right'}}/>
                </Col>
                
            </Row>
            <Row style={{ height: "8%" }} className="show-grid">
                <Col style={{ color: "white" }} xs={24} sm={24} md={14}>
                    <Row className="footerAction" style={{fontSize:'1.7vh'}}>
                        <label style={{ color: "#A4F504" }}>Actions: </label>
                        {/* <i style={{ padding: "0.4%", marginRight: 0 }} className="fa fa-check acceptIcon" aria-hidden="true"></i> */}
                        <CheckBoxIcon sx={{ color: 'green', padding:'0.4%', marginRight:'0', height:'3.3vh', width:'3.2vh' }}  />
                         - Accept
                    </Row>
                </Col>
                <Col xs={24} sm={24} md={7}>
                    {/* <label style={{ color: "#A4F504" }}>Agree with recommended info.: </label> */}
                </Col>
                <Col xs={24} sm={24} md={3}>
                    {/* <Toggle style={checked ? {} : { backgroundColor: "#6b6a6a" }} checkedChildren="Yes" unCheckedChildren="No" checked={checked} onChange={this.AsyncToggle} /> */}
                </Col>
            </Row>
            </Row>

        </>
    }
}
